import React, { Component } from "react";

import burger_and_friends from "images/custom/login/burger-san_and_friends.png";

import localize from "lang/localize";

class LoginImageRow extends Component {
  render() {
    return (
      <div className="innerblock pure-g">
        <div className="pure-u-1-12" />
        <div className="pure-u-5-6">
          <img
            src={burger_and_friends}
            className="imgresponsive"
            alt={localize("gourmetgrammar_mascot_text", this.props.language)}
          />
        </div>
        <div className="pure-u-1-12" />
      </div>
    );
  }
}

export default LoginImageRow;
